type GtagFn = (...args: unknown[]) => void;

const AW_ID = "AW-11408967890";

const CONVERSIONS = {
  chatLead: { label: "jvycCPnphqscENKRnMAq", value: 8500 },
  escalationLead: { label: "fv63CI-c8aocENKRnMAq", value: 15000 },
} as const;

function gtag(): GtagFn | null {
  try {
    const w = window as unknown as { gtag?: GtagFn };
    return typeof w.gtag === "function" ? w.gtag : null;
  } catch {
    return null;
  }
}

export type LeadUserData = { name?: string | null; email?: string | null };

function setUserData(g: GtagFn, ud: LeadUserData | undefined): void {
  if (!ud) return;
  const payload: Record<string, string> = {};
  if (ud.email) payload.email = String(ud.email).trim().toLowerCase();
  if (ud.name) {
    const parts = String(ud.name).trim().split(/\s+/);
    if (parts.length > 0 && parts[0]) payload.first_name = parts[0];
    if (parts.length > 1) payload.last_name = parts.slice(1).join(" ");
  }
  if (payload.email) {
    try {
      g("set", "user_data", payload);
    } catch {
      /* noop */
    }
  }
}

export function trackChatOpened() {
  const g = gtag();
  if (!g) return;
  g("event", "iskra_chat_opened", {
    event_category: "iskra_chat",
    event_label: "tab_click",
  });
}

export function trackChatEngaged() {
  const g = gtag();
  if (!g) return;
  g("event", "iskra_chat_engaged", {
    event_category: "iskra_chat",
    event_label: "first_message",
  });
}

export function trackChatLead(userData?: LeadUserData) {
  const g = gtag();
  if (!g) return;
  setUserData(g, userData);
  g("event", "conversion", {
    send_to: `${AW_ID}/${CONVERSIONS.chatLead.label}`,
    value: CONVERSIONS.chatLead.value,
    currency: "NOK",
  });
  g("event", "iskra_chat_lead", {
    event_category: "iskra_chat",
    value: CONVERSIONS.chatLead.value,
    currency: "NOK",
  });
}

export function trackEscalationLead(userData?: LeadUserData) {
  const g = gtag();
  if (!g) return;
  setUserData(g, userData);
  g("event", "conversion", {
    send_to: `${AW_ID}/${CONVERSIONS.escalationLead.label}`,
    value: CONVERSIONS.escalationLead.value,
    currency: "NOK",
  });
  g("event", "iskra_chat_escalation_lead", {
    event_category: "iskra_chat",
    value: CONVERSIONS.escalationLead.value,
    currency: "NOK",
  });
}

// Calendly CTA-klikk fra Iskra. Micro-conversion / engagement-event.
// Selve Calendly-bookingen tracker vi via separat Calendly-lead i n8n.
export function trackCalendlyClick(userData?: LeadUserData) {
  const g = gtag();
  if (!g) return;
  setUserData(g, userData);
  g("event", "iskra_calendly_click", {
    event_category: "iskra_chat",
    event_label: "cta_click",
  });
}

// Klikk på "Send oss en e-post"-CTA i en iskra-melding (static_fallback / escalate).
// Engagement-event — den ekte conversion fyres når kunden faktisk submitter
// escalation-formen via trackEscalationLead.
export function trackEscalationClick(userData?: LeadUserData) {
  const g = gtag();
  if (!g) return;
  setUserData(g, userData);
  g("event", "iskra_escalation_click", {
    event_category: "iskra_chat",
    event_label: "cta_click",
  });
}
